import Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import HighchartsExporting from "highcharts/modules/exporting";
import NoDataToDisplay from "highcharts/modules/no-data-to-display";
import { useEffect, useRef } from "react";

NoDataToDisplay(Highcharts);
HighchartsExporting(Highcharts);

const TimeSeriesChart = ({ data }) => {
  const chartRef = useRef(null);
  const sortedData = data?.sort((a, b) => a.timestamp - b.timestamp);
  const graphData =
    sortedData?.map((item) => [item?.imei, item?.timestamp, item?.value]) || [];
  
  useEffect(() => {
    if (chartRef.current) {
      if (!data) {
        chartRef.current.chart.showLoading("Loading...");
      } else {
        chartRef.current.chart.hideLoading();
      }
    }
  }, [data]);

  const getOptions = {
    chart: {
      type: "spline",
      height: 260,
      borderColor: "#e6e6e6",
      borderRadius: 0,
      borderWidth: 1,
      shadow: {
        color: "#e4e4e4",
        offsetX: 3,
        offsetY: 3,
        opacity: 0.4,
        width: 5,
      },
      spacing: [16, 16, 40, 16],
    },
    sonification: {
      tracks: [
        {
          roundToMusicalNotes: false,
        },
      ],
    },
    title: {
      text: "Time Series - Alerts",
      align: "left",
      margin: 20,
      style: {
        letterSpacing: "0.01071em",
        fontSize: "14px",
      },
    },
    exporting: {
      enabled: false,
    },
    legend: {
      enabled: true,
      layout: "vertical",
      backgroundColor: "#FFFFFF",
      align: "left",
      verticalAlign: "bottom",
      floating: true,
      itemMarginTop: 10,
      padding: 4,
      symbolWidth: 14,
      y: 32,
    },
    colors: ["#56a64b"],
    plotOptions: {
      series: {
        marker: {
          enabled: false,
          states: {
            hover: {
              enabled: true,
              radius: 3,
            },
          },
        },
      },
    },
    series: [
      {
        keys: ["name", "x", "y"],
        size: "95%",
        name: "Alerts",
        data: graphData,
        lineWidth: 2,
        states: {
          hover: {
            enabled: true,
            lineWidthPlus: 0,
          },
        },
        tooltip: {
          pointFormat: "{series.name}: <b>{point.y:.1f}</b><br/>",
          shared: true,
        },
      },
    ],
    credits: {
      enabled: false,
    },
    xAxis: {
      type: "datetime",
      gridLineWidth: 1,
      gridLineColor: "#e6e6e6",
      tickWidth: 1,
      tickColor: "#e6e6e6",
      lineWidth: 0,
      labels: {
        format: "{value:%m/%d %H:%M}",
      },
    },
    yAxis: {
      title: {
        text: "",
      },
    },
    lang: {
      noData: data ? "No data" : "",
    },
    noData: {
      style: {
        fontWeight: "normal",
        fontSize: "18px",
        color: "#828282",
      },
    },
  };

  return (
    <div>
      <HighchartsReact highcharts={Highcharts} options={getOptions} ref={chartRef} />
    </div>
  );
};

export default TimeSeriesChart;
